let timerId;

export function debounce(func, delay) {
  return (...args) => {
    const context = this;

    // Cancela o timer anterior se houver uma nova chamada
    clearTimeout(timerId);

    // Cria um novo timer para a próxima execução da função
    timerId = setTimeout(() => {
      func.apply(context, args);
    }, delay);
  };
}
